// extracted by mini-css-extract-plugin
export default {"docs":"Docs_docs__RfIzd","docItem":"Docs_docItem__OTkKF"};